import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Select from 'react-select';
import Searchbar from '../../../components/Searchbar';

import Button from '../../../components/Button';
import BadgeStatus from '../../../components/Common/BadgeStatus';
import toastUtil from '../../../components/ToastNotification/ToastUtil';
import { GET, newFetch, POST } from '../../../helpers/fetch';
import { getSelectedSiteIds } from '../../../helpers/general';
import AppContext from '../../../store/App/contexts';

const Claims = () => {
  const { selectedClientID, selectedSiteID } = useContext(AppContext);
  const clientID = parseInt(selectedClientID, 10);
  const siteID = parseInt(selectedSiteID, 10);
  const siteIDs = getSelectedSiteIds(clientID, siteID);
  const siteIDsKey = siteIDs.join(',');
  const userID = JSON.parse(localStorage.getItem('user') || '{}')?.id;
  const type = localStorage.getItem('type');
  const [loading, setLoading] = useState(true);
  const [claims, setClaims] = useState([]);
  const [claimTypes, setClaimTypes] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const [sortModel, setSortModel] = useState([
    { field: 'updatedAt', sort: 'desc' },
  ]);
  const [totalRows, setTotalRows] = useState(0);
  const [data, setData] = useState([]);
  const [clients, setClients] = useState([]);
  const [adminClients, setAdminClients] = useState();
  const [searchText, setSearchText] = useState('');
  const currentYear = 'All';
  const currentMonth = 'All';

  const [year, setYear] = useState(currentYear);
  const [month, setMonth] = useState(currentMonth);

  const [filterYear, setFilterYear] = useState(currentYear);
  const [filterMonth, setFilterMonth] = useState(currentMonth);

  // State for multi-select filters
  const [nameFilter, setNameFilter] = useState([]);
  const [typeFilter, setTypeFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);

  // Filter options extracted from claims data
  const [nameOptions, setNameOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  // Prepare type options from configured types and the current claims data
  const typeOptions = Array.from(
    new Map(
      [
        ...claimTypes.map((type) => ({
          value: type.id,
          label: type.name,
        })),
        ...claims
          .filter((claim) => claim.type_id && claim.claim_type_name)
          .map((claim) => ({
            value: claim.type_id,
            label: claim.claim_type_name,
          })),
      ].map((option) => [Number(option.value), option])
    ).values()
  );

  const columns = [
    {
      field: 'id',
      headerName: 'Request ID',
      resizable: false,
      filterable: false,
      sortable: true,
      renderCell: (params) => (
        <div className="row">
          <div className="col-md-12">
            <Link className="text-primary" to={`/claim/edit/${params.row.id}`}>
              <span style={{ fontWeight: '700', fontSize: 14 }}>
                {params.row.id}
              </span>
            </Link>
          </div>
        </div>
      ),
    },
    {
      field: 'pb_cand_id',
      headerName: 'PB Candidate ID',
      flex: 0.5,
      sortable: false,
      resizable: false,
      filterable: false,
      hide: true,
      renderCell: (params) => <span>{params.row.pb_cand_id || ''}</span>,
    },
    {
      field: 'pb_jo_id',
      headerName: 'PB JO ID',
      flex: 0.5,
      sortable: false,
      resizable: false,
      filterable: false,
      hide: true,
      renderCell: (params) => <span>{params.row.pb_jo_id || ''}</span>,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => <BadgeStatus status={params.row.status} />,
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 0.7,
      sortable: true,
      resizable: false,
      filterable: false,
      renderCell: (params) => <span>{params.row.name || '--'}</span>,
    },
    {
      field: 'client',
      headerName: 'Client',
      flex: 0.7,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => <span>{params.row.client || '--'}</span>,
    },
    {
      field: 'sites',
      headerName: 'Site',
      flex: 0.7,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => (
        <span>{params.row.sites || params.row.site_name || '--'}</span>
      ),
    },
    {
      field: 'date_of_receipt',
      headerName: 'Date of Receipt',
      flex: 0.5,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => {
        return <span>{params.row.date_of_receipt || '--'}</span>;
      },
    },
    {
      field: 'claim_type_name',
      headerName: 'Type',
      flex: 0.5,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => <span>{params.row.claim_type_name || ''}</span>,
    },
    {
      field: 'receipt_no',
      headerName: 'Receipt No.',
      flex: 0.5,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => <span>{params.row.receipt_no || ''}</span>,
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 0.5,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => <span>{params.row.amount || ''}</span>,
    },
    {
      field: 'deduct_amount',
      headerName: 'Reimbursement',
      flex: 0.5,
      sortable: false,
      resizable: false,
      filterable: false,
      renderCell: (params) => <span>{params.row.deduct_amount || '--'}</span>,
    },
    {
      field: 'updatedAt',
      headerName: 'Date Modified',
      flex: 1,
      sortable: true,
      resizable: false,
      filterable: false,
      renderCell: (params) => <span>{params.row.updatedAt || '--'}</span>,
    },
  ];

  useEffect(() => {
    fetchAdminClients();
  }, []);

  useEffect(() => {
    if (clientID) fetchTypes();
  }, [clientID, siteIDsKey]);

  useEffect(() => {
    setNameFilter([]);
    setTypeFilter([]);
    setStatusFilter([]);
    setNameOptions([]);
    setStatusOptions([]);

    if (clientID) {
      fetchAllClaimsForFilters();
    }
  }, [clientID, siteIDsKey]);

  useEffect(() => {
    const { field, sort } = sortModel[0] || {};
    fetchClaims(paginationModel, field, sort, searchText);
    fetchClients();
  }, [
    sortModel,
    paginationModel,
    clientID,
    siteID,
    siteIDsKey,
    nameFilter,
    typeFilter,
    statusFilter,
    filterYear,
    filterMonth,
  ]);

  useEffect(() => {
    const { field, sort } = sortModel[0] || {};
    const delayDebounce = setTimeout(() => {
      fetchClaims(paginationModel, field, sort, searchText);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, paginationModel, sortModel]);

  useEffect(() => {
    setData(claims ?? []);
    claims && setLoading(false);
  }, [claims]);

  const fetchTypes = async () => {
    try {
      let api_path = `/claimtypes/${siteID}?client_id=${clientID}&site_ids=${siteIDs.join(
        ','
      )}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let claimTypes = response.data;
        setClaimTypes(claimTypes);
      } else {
        toastUtil.success(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchClaims = async (pagination, field, sort, search) => {
    try {
      setLoading(true);
      const fetchUrl = '/claims/list';
      const response = await newFetch(POST, fetchUrl, {
        field,
        sort,
        page: pagination.page,
        pageSize: pagination.pageSize,
        client_id: clientID,
        site_id: siteID,
        site_ids: siteIDs,
        sites: siteIDs,
        type,
        search: search || '',
        year: filterYear,
        month: filterMonth,
        names: nameFilter.map((opt) => opt.value),
        types: typeFilter.map((opt) => opt.value),
        statuses: statusFilter.map((opt) => opt.value),
      });

      if (!response.success) {
        console.log('error');
      } else {
        if (pagination.pageSize !== 99999) {
          setClaims(response.data.list);
          setTotalRows(response.data.total_record);
        } else {
          setLoading(false);
          return response.data.list;
        }

        if (nameOptions.length === 0 || statusOptions.length === 0) {
          extractFilterOptions(response.data.list);
        }

        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const fetchAllClaimsForFilters = async () => {
    try {
      const fetchUrl = '/claims/list';
      const response = await newFetch(POST, fetchUrl, {
        field: 'updatedAt',
        sort: 'desc',
        page: 0,
        pageSize: 1000,
        client_id: clientID,
        site_id: siteID,
        site_ids: siteIDs,
        sites: siteIDs,
        type,
        search: '',
        names: [],
        types: [],
        statuses: [],
      });

      if (response.success && response.data.list) {
        extractFilterOptions(response.data.list);
      }
    } catch (err) {
      console.log('Error fetching claims for filters:', err);
    }
  };

  const extractFilterOptions = (claimsData) => {
    if (!claimsData || claimsData.length === 0) return;

    const nameMap = new Map();
    claimsData
      .filter(
        (claim) => claim.name && claim.name.trim() !== '' && claim.associate_id,
      )
      .forEach((claim) => {
        if (!nameMap.has(claim.associate_id)) {
          nameMap.set(claim.associate_id, {
            id: claim.associate_id,
            name: `${claim.name || ''} ${claim.last_name || ''}`.trim(),
          });
        }
      });

    const nameOpts = Array.from(nameMap.values()).map((item) => ({
      value: item.id,
      label: item.name,
    }));

    const uniqueStatuses = [
      ...new Set(
        claimsData
          .filter((claim) => claim.status && claim.status.trim() !== '')
          .map((claim) => claim.status),
      ),
    ];

    const statusOpts = uniqueStatuses.map((status) => ({
      value: status,
      label: status,
    }));

    setNameOptions(nameOpts);
    setStatusOptions(statusOpts);
  };

  const fetchAdminClients = async () => {
    try {
      const fetchUrl = `/admin/admins-client/${userID}`;
      const response = await newFetch(GET, fetchUrl);

      if (response.success) {
        setAdminClients(response.data);
      }
    } catch (err) {
      console.error('Error fetching admin clients:', err);
    }
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
  };

  const fetchClients = async () => {
    let api_path = `/client/${clientID}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  const searchHandler = (e) => {
    setSearchText(e.target.value);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const exportToCSV = async (exportData, filename = 'claims.csv') => {
    if (!exportData || exportData.length === 0) {
      alert('No data to export!');
      return;
    }

    const fieldToHeader = {};
    columns.forEach((col) => {
      fieldToHeader[col.field] = col.headerName;
    });

    const headers = columns.map((col) => col.headerName);
    const csvRows = [];
    csvRows.push(headers.join(','));

    exportData.forEach((row) => {
      const values = columns.map((col) => {
        let val = row[col.field];

        if (col.field === 'name') {
          val = `${row.name || ''} ${row.last_name || ''}`.trim();
        }

        if (val === null || val === undefined) val = '';

        val = String(val).replace(/"/g, '""');
        return `"${val}"`;
      });
      csvRows.push(values.join(','));
    });

    const blob = new Blob([csvRows.join('\r\n')], {
      type: 'text/csv;charset=utf-8;',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleExport = async () => {
    setLoading(true);
    try {
      const exportData = await fetchClaims(
        { page: 0, pageSize: 99999 },
        sortModel[0]?.field || 'updatedAt',
        sortModel[0]?.sort || 'desc',
        searchText,
      );

      if (exportData && exportData.length > 0) {
        const filename = `claims_${filterYear || 'all'}_${
          filterMonth || 'all'
        }.csv`;
        await exportToCSV(exportData, filename);
      } else {
        toastUtil.error('No data found for export');
      }
    } catch (error) {
      console.error('Export error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '6rem',
      }}
    >
      {adminClients?.some((c) => c.client_id === clientID) ? (
        <>
          {clients.enable_claims ? (
            <>
              <div className="border-bottom pb-2 py-2 mb-2 d-flex align-items-center">
                <h6 className="flex-grow-1 pt-4" style={{ color: '#A6478E' }}>
                  Claims | All
                </h6>
              </div>

              <div className="d-flex flex-row align-items-center justify-content-between py-3">
                <h6 className="flex-grow-1">Claims ({totalRows})</h6>
              </div>

              <div className="row mb-3 align-items-end">
                {/* Name Filter - hidden */}
                {false && (
                  <div className="col-lg-2 col-md-4">
                    <div className="mb-3">
                      <label className="form-label font-size-13 text-muted">
                        Name
                      </label>
                      <Select
                        value={nameFilter}
                        onChange={setNameFilter}
                        isMulti
                        options={nameOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Select Names..."
                        isDisabled={nameOptions.length === 0}
                      />
                    </div>
                  </div>
                )}

                {/* Search Bar */}
                <div className="col-lg-2 col-md-4">
                  <div className="mb-3">
                    <Searchbar
                      search={searchHandler}
                      placeholder="Search ID or Name"
                      searchValue={searchText}
                    />
                  </div>
                </div>

                {/* Type Filter */}
                <div className="col-lg-2 col-md-4">
                  <div className="mb-3">
                    <label className="form-label font-size-13 text-muted">
                      Type
                    </label>
                    <Select
                      value={typeFilter}
                      onChange={setTypeFilter}
                      isMulti
                      options={typeOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Types..."
                    />
                  </div>
                </div>

                {/* Status Filter */}
                <div className="col-lg-2 col-md-4">
                  <div className="mb-3">
                    <label className="form-label font-size-13 text-muted">
                      Status
                    </label>
                    <Select
                      value={statusFilter}
                      onChange={setStatusFilter}
                      isMulti
                      options={statusOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Statuses..."
                      isDisabled={statusOptions.length === 0}
                    />
                  </div>
                </div>

                {/* Year Filter */}
                <div className="col-lg-2 col-md-4">
                  <div className="mb-3">
                    <label className="form-label font-size-13 text-muted">
                      Year
                    </label>
                    <select
                      className="form-select"
                      value={year ?? ''}
                      onChange={(e) => {
                        const val = e.target.value
                          ? Number(e.target.value)
                          : null;
                        setYear(val);
                        setFilterYear(val);
                        setPaginationModel((prev) => ({ ...prev, page: 0 }));
                      }}
                    >
                      <option value="">All</option>
                      {Array.from(
                        { length: new Date().getFullYear() - 2025 + 1 },
                        (_, i) => 2025 + i,
                      ).map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Month Filter */}
                <div className="col-lg-2 col-md-4">
                  <div className="mb-3">
                    <label className="form-label font-size-13 text-muted">
                      Month
                    </label>
                    <select
                      className="form-select"
                      value={month ?? ''}
                      onChange={(e) => {
                        const val = e.target.value
                          ? Number(e.target.value)
                          : null;
                        setMonth(val);
                        setFilterMonth(val);
                        setPaginationModel((prev) => ({ ...prev, page: 0 }));
                      }}
                    >
                      <option value="">All</option>
                      {[
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                      ].map((m, index) => (
                        <option key={index + 1} value={index + 1}>
                          {m}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Export Button */}
                <div className="col-lg-2 col-md-4">
                  <div className="mb-3">
                    <label
                      className="form-label font-size-13 text-muted"
                      style={{ visibility: 'hidden' }}
                    >
                      Hidden
                    </label>
                    <Button
                      title={'Export CSV'}
                      loading={loading}
                      onClick={handleExport}
                      assignClassName={
                        'btn btn-outline-secondary w-100 adjust-fs adjust-shadow'
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="table-responsive rounded shadow bg-white">
                <Box sx={{ width: '100%' }}>
                  {data && (
                    <DataGrid
                      columns={columns.filter((claim) => !claim.hide)}
                      rows={data || []}
                      rowCount={totalRows || 1}
                      loading={loading}
                      pageSizeOptions={[10, 20, 30, 40, 50, 80, 100]}
                      paginationModel={paginationModel}
                      paginationMode="server"
                      sortingMode="server"
                      onPaginationModelChange={setPaginationModel}
                      sortModel={sortModel}
                      onSortModelChange={handleSortModelChange}
                      sx={{
                        [`& .${gridClasses.columnHeader}`]: {
                          fontSize: '14px',
                          fontWeight: 700,
                        },
                        [`& .${gridClasses.row}`]: {
                          fontSize: '12px',
                          color: '#212529 !important',
                        },
                      }}
                      disableSelectionOnClick
                      isRowSelectable={() => false}
                    />
                  )}
                </Box>
              </div>
            </>
          ) : (
            <div className="text-muted pt-4">
              The client does not have access to this module.
            </div>
          )}
        </>
      ) : (
        <div className="text-muted pt-4">
          The admin does not have access to this client.
        </div>
      )}
    </div>
  );
};

export default withRouter(Claims);
